import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';

/**
 * Lightweight hook that returns just the current user's profile ID.
 * Used for scoped matching operations.
 */
export function useMyProfileId() {
  const { data } = useQuery({
    queryKey: ['my-profile'],
    queryFn: () => apiFetch<{ id: string } | null>('/profiles/me'),
    staleTime: 60_000 // Cache for 1 minute
  });
  return data?.data?.id ?? null;
}
